import React from 'react';

import posed/*, { PoseGroup }*/ from 'react-pose';
import Select from 'react-select';
import {ResponsiveLine} from '@nivo/line'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Circle } from "react-google-maps"
import { Textfit } from 'react-textfit'

import Validation from '../DarwinReactLibrary/js/Validation.js';
//import * as Generation from './Generation.js';
import API from './API.js';
import * as Helpers from './Helpers.js';

import ImageMailRed from './images/MailRed.svg'
import ImageMailWhite from './images/MailWhite.svg'
import ImageBidlyLogoWhite from './images/HallPassWhite.svg'
import ImageBidlyLogoDarkSpacing from './images/HallPassColored.svg'
import ImagePlusButtonPurple from './images/PlusButtonPurple.svg'
import ImageHelpIcon from './images/HelpIcon.svg'
import ImageXButton from './images/XButton.svg'
import ImageAssociateDark from './images/AssociateDark.svg'
import ImageCreditCardCheckmark from './images/CreditCardCheckmark.svg'
import ImagePayPalLogoSmall from './images/PayPalLogoSmall.svg'
import ImageCalendarMonthly from './images/CalendarMonthly.svg'
import ImageCalendarOnce from './images/CalendarOnce.svg'
import ImageNoLocation from './images/NoLocation.svg'
import ImageShopColored from './images/ShopColored.svg'
import ImageShopHollow from './images/ShopHollow.svg'
import ImageShopColoredPurple from './images/ShopColoredPurple.svg'

//PROMOTION PREVIEW IMAGES
import ImagePromotionDownArrow from './images/PromotionDownArrow.svg'
import ImageBidlyPattern from './images/BidlyPattern.png'
import ImageMapPointIcon from './images/MapPointIcon.svg'
import ImageHeartRed from './images/HeartRed.svg'
//import ImageBarcodeWhite from './images/BarcodeWhite.svg'
//import ImageBarcodeGray from './images/BarcodeGray.svg'
import ImageLocationWhite from './images/LocationWhite.svg'
import ImageLocationGray from './images/LocationGray.svg'
//import ImageLocationBlack from './images/LocationBlack.svg'
import ImageClockGray from './images/ClockGray.svg'
import ImageInfoBlack from './images/InfoBlack.svg'
import ImageMapPointIconDark from './images/MapPointIconDark.svg'
import ImageClockDark from './images/ClockDark.svg'
import ImagePhoneDark from './images/PhoneDark.svg'
import ImageSiteDark from './images/SiteDark.svg'
import ImageTwitterDark from './images/TwitterDark.svg'
import ImageFacebookDark from './images/FacebookDark.svg'
import ImageInstagramDark from './images/InstagramDark.svg'
import ImageCheckmark from './images/Checkmark.svg'
import ImageUncheckmark from './images/Uncheckmark.svg'

//Changes the image on hover to the dual image
//set properties image, hoverimage, ...
export class DualImage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      hovering: false
    }
  }

  //true or false we are hovering
  hover(h) {
    this.setState({
      hovering: h
    })
  }

  render() {

    /*if (this.props.image === false) {
      <img onMouseOver={this.hover.bind(this, true)} onMouseLeave={this.hover.bind(this, false)} {...this.props}/>
    }*/
    let src = this.props.image
    if (this.state.hovering && this.props.hoverimage) {
      src = this.props.hoverimage
    }
    return (
      <img className={"dualImage " + (this.props.className ? this.props.className : "")}
      onMouseOver={this.hover.bind(this, true)} onMouseLeave={this.hover.bind(this, false)} alt="hover over me"
      src={src} {...this.props}
      style={this.props.style || {}}
      onClick={this.props.onClick ? this.props.onClick : undefined}
      />
    );
  }
}

export class MaterialButton extends React.Component {

  render() {

    let bclass = ""
    switch (this.props.type) {
      case "White":
        bclass = "MaterialButtonWhite"
        break;
      case "Red":
        bclass = "MaterialButtonRed"
        break;
      case "LightRed":
        bclass = "MaterialButtonLightRed"
        break;
      case "Green":
        bclass = "MaterialButtonGreen"
        break;
      case "LightGreen":
        bclass = "MaterialButtonLightGreen"
        break;
      case "Purple":
        bclass = "MaterialButtonPurple"
        break;
      case "LightPurple":
        bclass = "MaterialButtonLightPurple"
        break;
      case "TextDark":
        bclass = "MaterialButtonTextDark"
        break;
      case "TextDarkShadow":
        bclass = "MaterialButtonTextDarkShadow"
        break;
      case "TextRed":
        bclass = "MaterialButtonTextRed"
        break;
      case "TextRedShadow":
        bclass = "MaterialButtonTextRedShadow"
        break;
      case "TextPurpleShadow":
        bclass = "MaterialButtonTextPurpleShadow"
        break;
      case "TextGreenShadow":
        bclass = "MaterialButtonTextGreenShadow"
        break;
      case "PayPal":
        bclass = "MaterialButtonPayPal"
        break;
      default:
        break;
    }

    let sclass = ""
    switch (this.props.size) {
      case "Large":
        sclass = "MaterialButtonLarge"
        break;
      case "Small":
        sclass = "MaterialButtonSmall"
        break;
      case "Tiny":
        sclass = "MaterialButtonTiny"
        break;
      default:
        break;
    }

    let extraClasses = " "
    if (this.props.className) {
      extraClasses += this.props.className
    }

    return (
      <button type="button" className={"btn MaterialButton " + bclass + " " + sclass + (this.props.shake ? " AnimationShake" : "") + extraClasses}
        style={this.props.style} onClick={this.props.onClick}>{this.props.children}</button>
    )
  }
}

export class PayPalButton extends React.Component {

  constructor(props) {
    super(props)

    this.connectPayPal = this.connectPayPal.bind(this)
  }

  connectPayPal() {
    let testMethod = Helpers.isDevelopment() || this.props.userInfo.testAccount === "1"

    let base = "https://www.paypal.com/signin/authorize?"
    if (testMethod) {
      base = "https://www.sandbox.paypal.com/signin/authorize?"
    }
    base += "flowEntry=static"
    base += "&client_id=" + encodeURIComponent(testMethod ? "AZJwIXDXZie_LkvFrpkmn6qI7jAnIsWlgpCbTu_o7jEVOP7gJ90Q6PZxqns1q0jVlr8NgoaNWDjhxS6A" : "AUf_DMpLmG5djeRHoFGWP-q1fm5RmCjkZ4Y7DwtReChTF3tQhKZD4z9ERm8_BODbxKxIf-IUbrsXJMJ1")
    base += "&scope=" + encodeURIComponent("openid profile email https://uri.paypal.com/services/paypalattributes")

    let state = this.props.userInfo.id + "_" + Helpers.randomString(12)
    //Store the state parameter
    API.setCookie("PayPalConnectState", state, 600)
    base += "&redirect_uri=" + encodeURIComponent(testMethod ? "http://localhost:3000/PayPalToken?state=" + state : "https://portal.get-the-pass.com/PayPalToken?state=" + state)
    base += "&response_type=code"
    base += "&fullPage=true"

    //Redirect to this page.
    window.location.href = base
  }

  render() {
    return (
      <div>
        <img className="PayPalButton" onClick={this.connectPayPal} src="https://www.paypalobjects.com/webstatic/en_US/developer/docs/login/connectwithpaypalbutton.png" alt="PayPal Logo" />
      </div>
    )
  }
}

export class MessageButton extends React.Component {

  render() {
    return (
      <div className="MessageButton" onClick={this.props.onClick}>
        { this.props.number > 0 &&
          <span>
            <DualImage image={ImageMailRed} hoverimage={ImageMailRed} />
            <div className="MessageButtonIndicator">
              { this.props.number }
            </div>
          </span>
        }
        { this.props.number === 0 &&
          <DualImage image={ImageMailWhite} hoverimage={ImageMailRed} />
        }
      </div>
    )
  }
}

export const DropDown = posed.div({
  visible: {
    y: 0,
    opacity: 1,
  },
  hidden: {
    y: -20,
    opacity: 0
  }
})

export class LoadingIndicator extends React.Component {

  render() {

    let style = {
    }
    if (this.props.top) {
      style["marginTop"] = this.props.top
    }
    if (this.props.bottom) {
      style["marginBottom"] = this.props.bottom
    }
    return (
      <div className="la-ball-scale-multiple la-purple la-2x" style={style}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    )
  }
}

export class Popup extends React.Component {

  render() {
    return (
      <div className={"Popup " + (this.props.main === "Success" ? "PopupSuccess" : "")}>
        <div className="PopupContainer">
          <div className="PopupMain">{this.props.main}</div>
          <div className="PopupTitle">{this.props.title}</div>
          <div className="PopupDescription">{this.props.description}</div>
          <div className="ButtonDiv">
            <MaterialButton type={this.props.main === "Success" ? "Green" : "Red"} size="Large" onClick={this.props.dismiss}>Ok</MaterialButton>
          </div>
        </div>
      </div>
    )
  }
}

export class Confirmation extends React.Component {

  render() {
    return (
      <div className="Popup PopupPurple">
        <div className="PopupContainer">
          <div className="PopupMain">{this.props.main}</div>
          <div className="PopupTitle">{this.props.title}</div>
          <div className="PopupDescription">{this.props.description}</div>
          <div className="ButtonDiv">
            <MaterialButton type="Purple" size="Large" style={{marginRight:"20px", marginLeft:"20px", marginBottom:"30px"}} onClick={() => {this.props.action(true)}}>{this.props.accept}</MaterialButton>
            <MaterialButton type="TextRedShadow" size="Large" onClick={() => {this.props.action(false)}}>{this.props.deny}</MaterialButton>
          </div>
        </div>
      </div>
    )
  }
}

export class CreditCard extends React.Component {

  render() {
    return (
      <div className="CreditCard">
        <div className="CreditCardTopLine">
          <DualImage image={ImageBidlyLogoWhite} />
          <div className="CreditCardTitle">Card</div>
        </div>
        <div className="CreditCardMiddleLine">
          <div className="CreditCardNumber">
            ****&nbsp;&nbsp;&nbsp;****&nbsp;&nbsp;&nbsp;****&nbsp;&nbsp;&nbsp;{ this.props.last4 }
          </div>
        </div>
        <div className="CreditCardBottomLine">
          <div className="CreditCardExpiration">
            { (this.props.exp_month < 10 ? "0" + this.props.exp_month : this.props.exp_month) + " / " + ((this.props.exp_year + "").substring(2)) }
          </div>
          <div className="CreditCardBrand">
            { this.props.brand }
          </div>
        </div>
      </div>
    )
  }
}

export class InputBottomLine extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      valid: undefined,
      validResponse: undefined,
      failMessage: undefined
    }

    this.onKeyPress = this.onKeyPress.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSelectChange = this.onSelectChange.bind(this)
    this.onShopHoursChange = this.onShopHoursChange.bind(this)
    this.onFileSelectorChange = this.onFileSelectorChange.bind(this)
    this.onValidDaysChange = this.onValidDaysChange.bind(this)
    this.updateValidation = this.updateValidation.bind(this)
    this.changeFilter = this.changeFilter.bind(this)
  }

  componentDidUpdate(prevProps) {
    if ((!prevProps.forceCheck && this.props.forceCheck) || (prevProps.matchValue !== this.props.matchValue)) {
      this.updateValidation(this.props.value)
    }
  }

  onKeyPress(e) {
    if (e.keyCode === 13) {
      this.props.onEnter()
    }
  }

  onChange(e) {
    //validate this input and update the validation state.
    let val = e.target.value ? e.target.value : ""
    this.updateValidation(val)
  }

  onSelectChange(selection) {
    //console.log("selection: ", selection)
    let val = selection.value
    this.updateValidation(val)
  }

  onShopHoursChange(value, textValue) {
    //console.log("shopHoursValue: ", value)
    //console.log("shopHoursTextValue: ", textValue)
    //1) Validate the shopHours.
    if (this.updateValidation(value)) {
      //2) Update the shopHoursTextValue.
      this.props.onChange(this.props.name + "Text", textValue, true)
    }
  }

  onValidDaysChange(value) {
    //1) Validate the new value
    this.updateValidation(value)
  }

  onFileSelectorChange(url) {
    //console.log("file selection changes: ", url)
    this.updateValidation(url)
  }

  updateValidation(val) {
    let value = val
    let type = this.props.validation ? this.props.validation : "text"
    let req = this.props.required === "true" ? true : false
    let matchValue = this.props.matchValue ? this.props.matchValue : ""
    let min = this.props.minimum ? this.props.minimum : -1
    let max = this.props.maximum ? this.props.maximum : -1
    if (type === "phoneNumber" || type === "phoneNumber10") {
      value = value.replace(/[^0-9]/g, '')
      //console.log("value", value)
    } else if (type === "positiveNumber") {
      value = value.replace(/[^0-9]/g, '')
    } else if (type === "money") {
      //get rid of all non digits and non decimals.
      value = value.toString()
      value = value.replace(/[^0-9.]/g, '')
      //make sure there are only 2 digits after the decimal
      let pos = value.indexOf(".")
      if (pos !== -1) {
        value = value.substring(0, pos + 3)
      }
      //remove all leading zeros.
      if (value.length > 1) {
        while (value.indexOf("0") === 0) {
          value = value.substring(1)
        }
      }
      //add a leading zero if needed.
      pos = value.indexOf(".")
      if (pos === 0) {
        value = "0" + value
      }
    }

    let result = {}
    if (matchValue) {
      result = Validation.validateMatch(value, type, req, matchValue, min, max);
    } else {
      result = Validation.validate(value, type, req, min, max);
    }

    this.setState({
      valid: result.valid,
      validResponse: result.validResponse,
      failMessage: result.failMessage
    })
    /*if (prevent) {
      e.preventDefault()
      return
    }*/
    this.props.onChange(this.props.name, value, result.valid)
    return result.valid
  }

  changeFilter() {
    let value = this.props.value
    for (let i = 0; i < this.props.options.length; i = i + 1) {
      if (this.props.options[i].value === value) {
        if (i + 1 < this.props.options.length) {
          value = this.props.options[i + 1].value
        } else {
          value = this.props.options[0].value
        }
        break
      }
    }
    this.props.onChange(this.props.name, value, true)
  }

  render() {
    let selectVal = null
    let selectIndex = 0
    let options = this.props.options
    if (this.props.type === "selection" || this.props.type === "filter") {
      if (options.length === 0) {
        options = [{
          value: "",
          label: "Loading ..."
        }]
        selectVal = options[0]
      }
      if (this.props.value) {
        for (let i = 0; i < this.props.options.length; i = i + 1) {
          if (this.props.value === this.props.options[i].value) {
            selectVal = this.props.options[i]
            selectIndex = i
            break
          }
        }
      }
      if (selectVal === null) {
        selectVal = options[0]
      }
    }

    let value = this.props.value
    if (value !== null && value.length > 0) {
      if (this.props.validation === "phoneNumber" || this.props.validation === "phoneNumber10") {
        //parse this into a phone number with (), spaces, and dashes
        value = Helpers.parsePhoneNumber(value)
      } else if (this.props.validation === "positiveNumber") {
        //parse this into a readable number
        value = Helpers.formatNumber(value)
      } else if (this.props.validation === "money") {
        //add in commas to the number before the decimal
        let pos = value.indexOf(".")
        //value = "$"
        if (pos === -1) {
          value = "$" + Helpers.formatNumber(value)
        } else {
          value = "$" + Helpers.formatNumber(value.substring(0, pos)) + "." + value.substring(pos + 1)
        }
      }
    }

    let inputStyle = {}
    if (this.props.center) {
      inputStyle.textAlign = "center"
    }

    if (this.props.type === "filter") {
      return (
        <div className={"inputFilter " + (selectIndex > 0 ? "inputFilterChanged" : "")}>
          <div className="inputFilterBox" onClick={this.changeFilter}>
            { selectVal.label }
          </div>
        </div>
      )
    } else {
      return (
        <div className={"inputBottomLineLightContainer " + (this.state.valid === false ? "inputBottomLineLightContainerInvalid" : (this.state.valid === true ? "inputBottomLineLightContainerValid" : ""))}>
          { this.props.title &&
            <div className="inputBottomLineTitle">
              { this.props.title }
            </div>
          }
          { this.props.description &&
            <div className="inputBottomLineDescription">
              { this.props.description }
            </div>
          }
          <div className="inputBottomLineInvalid">
            { this.state.failMessage }
          </div>
          { this.props.type === "selection" &&
            <Select
              tabIndex={this.props.tabIndex || ""}
              name={this.props.name}
              value={selectVal}
              onChange={this.onSelectChange}
              options={options}
              clearable={false}
              className="react-select-container"
              classNamePrefix="react-select"
            />
          }
          { this.props.type === "shopHours" &&
            <ShopHours
              tabIndex={this.props.tabIndex || ""}
              name={this.props.name}
              value={value}
              onChange={this.onShopHoursChange}
            />
          }
          { this.props.type === "validDays" &&
            <ValidDaysInput
              tabIndex={this.props.tabIndex || ""}
              name={this.props.name}
              value={value}
              onChange={this.onValidDaysChange}
            />
          }
          { this.props.type === "file" &&
            <FileSelectorDiv
              tabIndex={this.props.tabIndex || ""}
              name={this.props.name}
              value={value}
              onChange={this.onFileSelectorChange}
              APIName={this.props.APIName}
              APIUploadName={this.props.APIUploadName}
              showPopup={this.props.showPopup}
              maxSize={this.props.maxSize}
            />
          }
          { (this.props.type === "text" || this.props.type === "password") &&
            <div className="inputBottomLineLightFlexBox">
              { this.props.type === "money" &&
                <div className="moneyInputSign">
                  $
                </div>
              }
              <input tabIndex={this.props.tabIndex ? this.props.tabIndex : ""} type={this.props.type ? this.props.type : "text"}
                name={this.props.name} className="inputBottomLineLight" placeholder={this.props.placeholder} value={value}
                style={inputStyle}
                onKeyDown={this.onKeyPress} onChange={this.onChange} />
            </div>
          }
          <div style={{clear: "both"}}></div>
          <div className="inputBottomLineBlockLight"></div>
        </div>
      )
    }
  }
}

export class ValidDaysInput extends React.Component {

  getDays() {
    let dd = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    let results = []
    for (let i = 0; i < dd.length; i = i + 1) {
      results.push({
        day: dd[i],
        value: this.props.value.charAt(i) || "1"
      })
    }
    return results
  }

  flipDay(index) {
    let old = this.props.value.charAt(index) || "1"

    let newValue = ""
    if (old === "1") {
      //flip to 0
      newValue = this.props.value.substr(0, index) + "0" + this.props.value.substr(index + 1)
    } else {
      //flip to 1
      newValue = this.props.value.substr(0, index) + "1" + this.props.value.substr(index + 1)
    }

    //tell the parent the value was updated.
    this.props.onChange(newValue)
  }

  render() {
    let days = this.getDays()
    return (
      <div className="ValidDaysInput">
        { days.map((day, i) => (
          <div key={"day_" + i} className="ValidDaysInputDay" onClick={this.flipDay.bind(this, i)}>
            <DualImage image={day.value === "1" ? ImageCheckmark : ImageUncheckmark} className="ValidDaysInputDayImage" />
            <div className={"ValidDaysInputDayName " + (day.value === "1" ? "ValidDaysInputDayNameSelected" : "")}>
              {day.day}
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export class FileSelectorDiv extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      overlay: false,
      imgError: false,
    }

    this.goToSelectFile = this.goToSelectFile.bind(this)
    this.selectedFile = this.selectedFile.bind(this)
    this.imageLoadError = this.imageLoadError.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        imgError: false
      })
    }
  }

  goToSelectFile() {
    this.setState({
      overlay: true
    })
  }

  selectedFile(file) {
    this.setState({
      overlay: false
    })
    if (file.length === 0) {
      //we didn't select anything
      return
    }
    //set this as the newly selected file
    this.props.onChange(file)
  }

  imageLoadError() {
    console.log("image load error")
    this.setState({
      imgError: true
    })
  }

  render() {

    let value = this.props.value
    if (value === null || value.length === 0 || this.state.imgError) {
      value = ImageBidlyLogoDarkSpacing
    }

    let fullScreenFileSelectorProps = {
      finished: this.selectedFile,
      APIName: this.props.APIName,
      APIUploadName: this.props.APIUploadName,
      showPopup: this.props.showPopup,
      maxSize: this.props.maxSize,
    }

    return (
      <div className="FileSelectorDiv">
        <img className="FileSelectorDivImage" src={value} onError={this.imageLoadError} alt="Selected Logo" />
        <MaterialButton type="TextPurpleShadow" onClick={this.goToSelectFile}>Select File</MaterialButton>
        { this.state.overlay &&
          <FullScreenFileSelector {...fullScreenFileSelectorProps} />
        }
      </div>
    )
  }
}

export class FullScreenFileSelector extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      files: [],
      uploadingFile: false,
    }

    this.loadFiles = this.loadFiles.bind(this)
    this.cancel = this.cancel.bind(this)
    this.fileSelected = this.fileSelected.bind(this)

    this.filePicker = React.createRef();
  }

  componentDidMount() {
    //Load from the API
    this.loadFiles()
  }

  loadFiles() {
    this.setState({
      loading: true
    }, () => {
      API.callDarwinAPI("GET", this.props.APIName, {}, (result) => {
        if ("error" in result) {
          this.props.showPopup("Error", "Couldn't load your files", result.error)
          return
        }
        this.setState({
          files: result.data,
          loading: false
        })
      })
    })
  }

  cancel() {
    this.props.finished("")
  }

  fileSelected() {
    if (this.filePicker.current.files.length === 0) {
      //no file selected
      return
    }
    let file = this.filePicker.current.files[0]

    this.setState({
      uploadingFile: true
    }, () => {
      //1) Read the File
      let reader = new FileReader();
      reader.onload = (e) => {
        let img = document.createElement("img");
        img.onload = () => {
          //2) Wait for the file to load then resize the image
          let canvas = document.createElement('canvas');
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          let MAX_WIDTH = this.props.maxSize;
          let MAX_HEIGHT = this.props.maxSize;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          //3) Convert the image to a blob
          canvas.toBlob((blob) => {

            //4) Call the API to retrieve signed post parameters
            API.callDarwinAPI("POST", this.props.APIUploadName, {}, (result) => {
              if ("error" in result) {
                this.props.showPopup("Error", "Couldn't load your files", result.error)
                return
              }
              //5) Upload the file.
              let formInputs = result.data.formInputs
              formInputs["Content-Type"] = "image/png"
              formInputs["Cache-Control"] = "max-age=2592000"
              API.uploadFileToS3(result.data.formAttributes, result.data.formInputs, result.data.filePath, blob, (result) => {
                console.log("file upload result", result)
                if (typeof result !== 'object' || "error" in result) {
                  //5) If error, show a popup to the user and stop loading.
                  this.setState({
                    uploadingFile: false
                  })
                  this.props.showPopup("Error", "Couldn't upload your file", result)
                  return
                } else {
                  //6) Cancel, go back, and reload the images.
                  this.setState({
                    uploadingFile: false
                  }, () => {
                    this.loadFiles()
                  })
                }
              })
            })
          }, "image/png")
        }
        img.src = e.target.result;
      }
      reader.readAsDataURL(file);
    })
  }

  render() {
    return (
      <div className="FullScreenFileSelector">
        { this.state.uploadingFile &&
          <div className="FullScreenFileSelectorFileLoading">
            <LoadingIndicator />
          </div>
        }
        { !this.state.uploadingFile &&
          <span>
            <div className="FullScreenFileSelectorTitle">File Selector</div>
            <div className="FullScreenFileSelectorDescription">Select an image or upload a new image using the plus button below.</div>
            <div className="FullScreenFileSelectorFileTypes">We accept png and jpg/jpeg files.</div>
            <div className="ButtonDiv">
              <MaterialButton type="TextRedShadow" size="Large" onClick={this.cancel}>Cancel</MaterialButton>
            </div>
            <div className="FullScreenFileSelectorContainer">
              { this.state.loading &&
                <div className="FullScreenFileSelectorFileLoading">
                  <LoadingIndicator top="68px" />
                </div>
              }
              { !this.state.loading &&
                <div className="FullScreenFileSelectorFiles">
                  <div className="FullScreenFileSelectorFileUpload">
                    <input id="FullScreenFile" className="FullScreenFileUploaderInput" type="file" ref={this.filePicker} onChange={this.fileSelected} accept="image/png, image/jpeg" />
                    <label htmlFor="FullScreenFile">
                      <img src={ImagePlusButtonPurple} alt="Upload" />
                    </label>
                  </div>
                  { !this.state.loading && this.state.files.map((file, i) => (
                    <div key={"file" + i} className="FullScreenFileSelectorFile" onClick={() => {this.props.finished(file.url)}}>
                      <img src={file.url} alt={"Icon " + i} />
                    </div>
                  ))}
                </div>
              }
            </div>
          </span>
        }
      </div>
    )
  }
}

export class ShopHours extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
    }

    this.parseTimeslots = this.parseTimeslots.bind(this)
    this.padNumber = this.padNumber.bind(this)
    this.onChange = this.onChange.bind(this)
    this.dayToAbbreviation = this.dayToAbbreviation.bind(this)
  }

  /*
  Parses the timeslots out of the days and returns it as an array of day timeslots
  to be used with the ShopHour component.
  0 is returned for closed,
  1 is returned for All Day,
  otherwise a range like "08:00-14:00" which means (8AM - 2PM).
  */
  parseTimeslots(value) {
    let days = []
    let values = []
    if (value.length > 0) {
      values = value.split(",")
    }
    for (let i = 0; i < 7; i = i + 1) {
      //calculate the start and stop times for the day
      let startTime = i * 24
      let stopTime = (i + 1) * 24
      let stopTimeExtended = stopTime + 4

      let foundRange = "0" //0 is closed, 1 is all day, otherwise it is the number.
      //find any ranges that cover this timerange
      for (let r = 0; r < values.length; r = r + 1) {
        let times = values[r].split("-")
        //parse the start time for this range
        let rangeStartTime = parseFloat(times[0].replace(":", "."))
        let rangeStartHour = parseInt(times[0].split(":")[0])
        let rangeStartMinute = parseInt(times[0].split(":")[1])
        //parse the stop time for this range
        let rangeStopTime = parseFloat(times[1].replace(":", "."))
        let rangeStopHour = parseInt(times[1].split(":")[0])
        let rangeStopMinute = parseInt(times[1].split(":")[1])

        //determine if the range belongs to this day (i)
        let inRange = false
        if (startTime >= rangeStartTime && startTime < rangeStopTime) {
          //range begins before today and ends sometime today.
          //console.log("start time of day " + i + " is in range: " + rangeStartTime + " - " + rangeStopTime)
          inRange = true
        } else if (stopTime <= rangeStopTime && stopTime > rangeStartTime) {
          //range begins sometime today and ends after tonight.
          //console.log("stop time of day " + i + " is in range: " + rangeStartTime + " - " + rangeStopTime)
          inRange = true
        } else if (startTime < rangeStartTime && stopTime > rangeStopTime) {
          //range begins sometime today and ends sometime today.
          //console.log("day " + i + " contains range: " + rangeStartTime + " - " + rangeStopTime)
          inRange = true
        }

        if (inRange) {
          //we found the range for this day, now calculate the start and end time on a 0-24 hour schedule
          //Note: if the time ends from 24-28 hours then use a 0-28 hour schedule, otherwise use a 0-24 hour schedule
          let stHour = 0
          let stMinute = 0
          let endHour = 24
          let endMinute = 0

          if (rangeStartTime > startTime) {
            stHour = rangeStartHour - (i * 24)
            stMinute = rangeStartMinute
          }
          if (rangeStopTime <= stopTimeExtended) {
            endHour = rangeStopHour - (i * 24)
            endMinute = rangeStopMinute
          }

          if (stHour === 0 && stMinute === 0 && ((endHour * 100) + endMinute) <= 400) {
            //this is a carryover from a previous days range like (8PM - 4AM) so it doesn't belong to this day.
            continue;
          }

          if (stHour === 0 && stMinute === 0 && endHour === 24 && endMinute === 0) {
            //Open All Day
            foundRange = "1"
          } else {
            foundRange = this.padNumber(stHour, 2) + ":" + this.padNumber(stMinute, 2) + "-" + this.padNumber(endHour, 2) + ":" + this.padNumber(endMinute, 2)
          }
          break;
        }
      }
      days.push(foundRange)
    }
    return days
  }

  /*
  Pads a number with leading zeros.
  */
  padNumber(number, digits = 2) {
    let pad = ""
    for (let i = 0; i < digits; i = i + 1) {
      pad += "0"
    }
    let dmax = Math.max(digits, ("" + number).length)
    return (pad + number).slice(-dmax)
  }

  /*
  Parses the change to a day's time and updates the value for the whole week.
  */
  onChange(day, time1, time2) {
    //1) First parse into timeslots the previous value.
    let timeslots = this.parseTimeslots(this.props.value)
    //2) Update the day that was edited.
    let newValue = time1 + "-" + time2
    if (time1 === "0" || time1 === "1") {
      newValue = time1
    }
    timeslots[day] = newValue
    //3) Combine the timeslots into groups for days with the same hours.
    // this will look like "08:00-12:00": [1, 2, 3] //1,2,3 for the days of the week with these hours.
    let combined = "" //the real value that is stored in the DB like "00:00-24:00,30:00-40:00,54:00-64:00"
    let textGroups = {}
    for (let i = 0; i < timeslots.length; i = i + 1) {
      let addString = "" //the timerange string to add to the real value that is stored in the DB.
      if (timeslots[i] === "0") {
        //nothing to do as this is a closed date.
        if ("0" in textGroups) {
          textGroups["0"].push(i)
        } else {
          textGroups["0"] = [i]
        }
        continue;
      } else if (timeslots[i] === "1") {
        let startHour = 24 * i
        let endHour = 24 * (i + 1)
        addString = this.padNumber(startHour, 2) + ":00-" + this.padNumber(endHour, 2) + ":00"

        if ("1" in textGroups) {
          textGroups["1"].push(i)
        } else {
          textGroups["1"] = [i]
        }
      } else {
        let times = timeslots[i].split("-")
        //parse the start and end times into relative hours and minutes.
        let rangeStartHour = parseInt(times[0].split(":")[0])
        let rangeStartMinute = parseInt(times[0].split(":")[1])
        let rangeStopHour = parseInt(times[1].split(":")[0])
        let rangeStopMinute = parseInt(times[1].split(":")[1])

        //get the 12 hour start and stop range.
        let textRangeStartHour = rangeStartHour % 12
        if (textRangeStartHour === 0) {
          textRangeStartHour = 12
        }
        let textRangeStopHour = rangeStopHour % 12
        if (textRangeStopHour === 0) {
          textRangeStopHour = 12
        }
        //create the 12 hour string representation
        let textString = this.padNumber(textRangeStartHour, 1) + ":" + this.padNumber(rangeStartMinute, 2) + "-" + this.padNumber(textRangeStopHour, 1) + ":" + this.padNumber(rangeStopMinute, 2)

        if (textString in textGroups) {
          textGroups[textString].push(i)
        } else {
          textGroups[textString] = [i]
        }

        //convert relative time to absolute time.
        rangeStartHour += 24 * i
        rangeStopHour += 24 * i

        //create the string for the DB.
        addString = this.padNumber(rangeStartHour, 2) + ":" + this.padNumber(rangeStartMinute, 2) + "-" + this.padNumber(rangeStopHour, 2) + ":" + this.padNumber(rangeStopMinute, 2)
      }
      //add to the combined string that stores the entire value.
      if (combined.length > 0) {
        combined += ","
      }
      combined += addString
    }

    //4) Parse the textGroups into a textString for display.
    let textValue = ""
    let available = [0, 1, 2, 3, 4, 5, 6]
    while (available.length > 0) {
      let searchDay = available[0]
      for (let key in textGroups) {
        if (textGroups[key].includes(searchDay)) {
          //found the day in this textGroup
          let days = textGroups[key]
          let last = -1
          let groupStart = -1
          let groupEnd = -1
          //if days are back to back then combine the strings.
          for (let i = 0; i < days.length; i = i + 1) {
            if (groupStart === -1) {
              //new group
              groupStart = days[i]
              groupEnd = days[i]
              last = days[i]
            } else if (days[i] === last + 1) {
              //extend the range of the group
              groupEnd = days[i]
              last = days[i]
            } else {
              //range of days is over add it to the textValue, then reset.
              if (textValue.length > 0) {
                textValue += ", "
              }
              textValue += this.dayToAbbreviation(groupStart)
              if (groupEnd !== groupStart) {
                textValue += "-" + this.dayToAbbreviation(groupEnd)
              }

              groupStart = days[i]
              groupEnd = days[i]
              last = days[i]
            }
            //remove this day from available days as we have processed it.
            available = available.filter((value, index, arr) => {
              return value !== days[i]
            })
          }
          //add in the range
          if (textValue.length > 0) {
            textValue += ", "
          }
          textValue += this.dayToAbbreviation(groupStart)
          if (groupEnd !== groupStart) {
            textValue += "-" + this.dayToAbbreviation(groupEnd)
          }
          //add in the text
          if (key === "0") {
            textValue += " Closed"
          } else if (key === "1") {
            textValue += " All Day"
          } else {
            textValue += " " + key
          }
          break
        }
      }
    }
    //5) Push the changes up to the next level.
    //console.log(combined, textValue)
    this.props.onChange(combined, textValue)
  }

  /*
  The day of the week, 0-6 where 0 is Monday.
  Converts to abbreviations like M, T, W, Th, F, Sa, Su
  */
  dayToAbbreviation(day) {
    switch (day) {
      case 0:
        return "M"
      case 1:
        return "Tu"
      case 2:
        return "W"
      case 3:
        return "Th"
      case 4:
        return "F"
      case 5:
        return "Sa"
      case 6:
        return "Su"
      default:
        return "?"
    }
  }

  render() {
    let timeslots = this.parseTimeslots(this.props.value)
    let hours = [
      {title:"Monday", day:0, value:timeslots[0]},
      {title:"Tuesday", day:1, value:timeslots[1]},
      {title:"Wednesday", day:2, value:timeslots[2]},
      {title:"Thursday", day:3, value:timeslots[3]},
      {title:"Friday", day:4, value:timeslots[4]},
      {title:"Saturday", day:5, value:timeslots[5]},
      {title:"Sunday", day:6, value:timeslots[6]},
    ]
    return (
      <div className="ShopHours">
        {hours.map((hour, i) => (
          <ShopHour key={"ShopHour" + i}
            {...hour}
            onChange={this.onChange}
          />
        ))}
      </div>
    )
  }
}

export class ShopHour extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
    }

    this.onChange = this.onChange.bind(this)
  }

  onChange(selection, action) {
    //get the old props.
    let startTime = this.props.value.split("-")[0]
    let endTime = this.props.value.split("-")[1]

    if (selection.value === "0" || selection.value === "1") {
      //Closed or All Day selected so send this as the value
      startTime = selection.value
      endTime = selection.value
    } else {
      if (action.name === "startTime") {
        startTime = selection.value
      } else {
        endTime = selection.value
      }
    }
    if (startTime === undefined) {
      startTime = "01:00"
    }
    if (endTime === undefined) {
      endTime = "23:00"
    }
    this.props.onChange(this.props.day, startTime, endTime)
  }

  render() {
    let fullOptions = [
      { value:"0", label:"Closed" },
      { value:"1", label:"All Day" },

      { value:"00:00", label:"Midnight" },
      { value:"00:15", label:"12:15 am" },
      { value:"00:30", label:"12:30 am" },
      { value:"00:45", label:"12:45 am" },

      { value:"01:00", label:"01:00 am" },
      { value:"01:15", label:"01:15 am" },
      { value:"01:30", label:"01:30 am" },
      { value:"01:45", label:"01:45 am" },

      { value:"02:00", label:"02:00 am" },
      { value:"02:15", label:"02:15 am" },
      { value:"02:30", label:"02:30 am" },
      { value:"02:45", label:"02:45 am" },

      { value:"03:00", label:"03:00 am" },
      { value:"03:15", label:"03:15 am" },
      { value:"03:30", label:"03:30 am" },
      { value:"03:45", label:"03:45 am" },

      { value:"04:00", label:"04:00 am" },
      { value:"04:15", label:"04:15 am" },
      { value:"04:30", label:"04:30 am" },
      { value:"04:45", label:"04:45 am" },

      { value:"05:00", label:"05:00 am" },
      { value:"05:15", label:"05:15 am" },
      { value:"05:30", label:"05:30 am" },
      { value:"05:45", label:"05:45 am" },

      { value:"06:00", label:"06:00 am" },
      { value:"06:15", label:"06:15 am" },
      { value:"06:30", label:"06:30 am" },
      { value:"06:45", label:"06:45 am" },

      { value:"07:00", label:"07:00 am" },
      { value:"07:15", label:"07:15 am" },
      { value:"07:30", label:"07:30 am" },
      { value:"07:45", label:"07:45 am" },

      { value:"08:00", label:"08:00 am" },
      { value:"08:15", label:"08:15 am" },
      { value:"08:30", label:"08:30 am" },
      { value:"08:45", label:"08:45 am" },

      { value:"09:00", label:"09:00 am" },
      { value:"09:15", label:"09:15 am" },
      { value:"09:30", label:"09:30 am" },
      { value:"09:45", label:"09:45 am" },

      { value:"10:00", label:"10:00 am" },
      { value:"10:15", label:"10:15 am" },
      { value:"10:30", label:"10:30 am" },
      { value:"10:45", label:"10:45 am" },

      { value:"11:00", label:"11:00 am" },
      { value:"11:15", label:"11:15 am" },
      { value:"11:30", label:"11:30 am" },
      { value:"11:45", label:"11:45 am" },

      { value:"12:00", label:"Noon" },
      { value:"12:15", label:"12:15 pm" },
      { value:"12:30", label:"12:30 pm" },
      { value:"12:45", label:"12:45 pm" },

      { value:"13:00", label:"01:00 pm" },
      { value:"13:15", label:"01:15 pm" },
      { value:"13:30", label:"01:30 pm" },
      { value:"13:45", label:"01:45 pm" },

      { value:"14:00", label:"02:00 pm" },
      { value:"14:15", label:"02:15 pm" },
      { value:"14:30", label:"02:30 pm" },
      { value:"14:45", label:"02:45 pm" },

      { value:"15:00", label:"03:00 pm" },
      { value:"15:15", label:"03:15 pm" },
      { value:"15:30", label:"03:30 pm" },
      { value:"15:45", label:"03:45 pm" },

      { value:"16:00", label:"04:00 pm" },
      { value:"16:15", label:"04:15 pm" },
      { value:"16:30", label:"04:30 pm" },
      { value:"16:45", label:"04:45 pm" },

      { value:"17:00", label:"05:00 pm" },
      { value:"17:15", label:"05:15 pm" },
      { value:"17:30", label:"05:30 pm" },
      { value:"17:45", label:"05:45 pm" },

      { value:"18:00", label:"06:00 pm" },
      { value:"18:15", label:"06:15 pm" },
      { value:"18:30", label:"06:30 pm" },
      { value:"18:45", label:"06:45 pm" },

      { value:"19:00", label:"07:00 pm" },
      { value:"19:15", label:"07:15 pm" },
      { value:"19:30", label:"07:30 pm" },
      { value:"19:45", label:"07:45 pm" },

      { value:"20:00", label:"08:00 pm" },
      { value:"20:15", label:"08:15 pm" },
      { value:"20:30", label:"08:30 pm" },
      { value:"20:45", label:"08:45 pm" },

      { value:"21:00", label:"09:00 pm" },
      { value:"21:15", label:"09:15 pm" },
      { value:"21:30", label:"09:30 pm" },
      { value:"21:45", label:"09:45 pm" },

      { value:"22:00", label:"10:00 pm" },
      { value:"22:15", label:"10:15 pm" },
      { value:"22:30", label:"10:30 pm" },
      { value:"22:45", label:"10:45 pm" },

      { value:"23:00", label:"11:00 pm" },
      { value:"23:15", label:"11:15 pm" },
      { value:"23:30", label:"11:30 pm" },
      { value:"23:45", label:"11:45 pm" },

      { value:"24:00", label:"Midnight" },
      { value:"24:15", label:"12:15 am" },
      { value:"24:30", label:"12:30 am" },
      { value:"24:45", label:"12:45 am" },

      { value:"25:00", label:"01:00 am" },
      { value:"25:15", label:"01:15 am" },
      { value:"25:30", label:"01:30 am" },
      { value:"25:45", label:"01:45 am" },

      { value:"26:00", label:"02:00 am" },
      { value:"26:15", label:"02:15 am" },
      { value:"26:30", label:"02:30 am" },
      { value:"26:45", label:"02:45 am" },

      { value:"27:00", label:"03:00 am" },
      { value:"27:15", label:"03:15 am" },
      { value:"27:30", label:"03:30 am" },
      { value:"27:45", label:"03:45 am" },

      { value:"28:00", label:"04:00 am" },
    ]

    //Find the value in the fullOptions given this.props.value
    let startValue = []
    let endValue = []
    let startOptions = fullOptions
    let endOptions = fullOptions
    let endDisabled = false
    if (this.props.value === "0") {
      startValue = fullOptions[0]
      endValue = fullOptions[0]
      endDisabled = true
    } else if (this.props.value === "1") {
      startValue = fullOptions[1]
      endValue = fullOptions[1]
      endDisabled = true
    } else {
      //we have a time to parse
      let startTime = this.props.value.split("-")[0]
      let endTime = this.props.value.split("-")[1]
      //now find the time
      for (let v = 0; v < fullOptions.length; v = v + 1) {
        if (fullOptions[v].value === startTime) {
          startValue = fullOptions[v]
        }
        if (fullOptions[v].value === endTime) {
          endValue = fullOptions[v]
        }
      }
    }

    return (
      <div className="ShopHour">
        {/* Show the day of the week */}
        <div className="ShopHourDay">{this.props.title}</div>
        {/* Show the first select option */}
        <Select
          name="startTime"
          options={startOptions}
          value={startValue}
          onChange={this.onChange}
          className="react-select-container ShopHourSelect"
          classNamePrefix="react-select"
        />
        {/* Show the dash */}
        <div className="ShopHourDash">–</div>
        {/* Show the second select option */}
        <Select
          name="stopTime"
          options={endOptions}
          value={endValue}
          onChange={this.onChange}
          isDisabled={endDisabled}
          className="react-select-container ShopHourSelect"
          classNamePrefix="react-select"
        />
      </div>
    )
  }
}

export class Statistic extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {
    let imgSrc = Helpers.getStatImage(this.props.type)
    let helpDescription = Helpers.getStatHelpDescription(this.props.type)

    return (
      <div className="Statistic" onClick={this.props.expand}>
        <div className="StatisticHelp">
          <DualImage image={ImageHelpIcon} />
          <div className="StatisticHelpPopup">
            <div className="StatisticHelpPopupTitle">
              {this.props.type}
            </div>
            <div className="StatisticHelpPopupDescription">
              {helpDescription}
            </div>
          </div>
        </div>
        <div>
          <img src={imgSrc} alt={this.props.type} className="StatisticImage" />
        </div>
        <div className="StatisticValue">
          {this.props.value}
        </div>
        <div className="StatisticType">
          {this.props.type}
        </div>
        <div className="StatisticDuration">
          {this.props.duration}
        </div>
      </div>
    )
  }
}

export class StatisticsGraph extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      data: [],
      newData: [],
      showing: ["Views", "Taps", "Favorites", "Intended", "Uses"],
      hoverData: {},
      daysToShow: 7, //defaults to a week
    }

    this.loadData = this.loadData.bind(this)
    this.dataReturned = this.dataReturned.bind(this)
    this.calculateDataToShow = this.calculateDataToShow.bind(this)
    this.toggleType = this.toggleType.bind(this)
    this.updateTopData = this.updateTopData.bind(this)
    this.changeTimescale = this.changeTimescale.bind(this)
  }

  componentDidMount() {
    this.loadData()
  }

  loadData() {
    this.props.loadData(this.dataReturned, this.state.daysToShow)
  }

  dataReturned(data) {
    let dd = data
    for (let i = 0; i < dd.length; i = i + 1) {
      let total = 0;
      for (let j = 0; j < dd[i].data.length; j = j + 1) {
        total += parseInt(dd[i].data[j].y)
      }
      dd[i].total = total
    }

    this.setState({
      data: dd,
      hoverData: {
      }
    }, () => {
      this.calculateDataToShow()
    })
  }

  calculateDataToShow() {
    this.setState((state) => {
      let newData = []
      for (let i = 0; i < state.data.length; i = i + 1) {
        if (state.showing.includes(state.data[i].id)) {
          newData.push(state.data[i])
        }
      }

      //find the totals.
      let totals = {}
      for (let i = 0; i < newData.length; i = i + 1) {
        totals[newData[i].id] = newData[i].total
      }

      return {
        newData: newData,
        hoverData: {
          Views: totals["Views"],
          Taps: totals["Taps"],
          Favorites: totals["Favorites"],
          Intended: totals["Intended"],
          Uses: totals["Uses"]
        },
      }
    })
  }

  /*
  Toggles showing a type of data.
  */
  toggleType(type) {
    this.setState((state) => {
      let showing = state.showing
      if (showing.includes(type)) {
        //remove the type
        showing = showing.filter(t => t !== type)
      } else {
        showing.push(type)
      }
      return {
        showing: showing,
        hoverData: {},
      }
    }, () => {
      this.calculateDataToShow()
    })
  }

  /*
  Updates the values for the top view when hovering over the data.
  */
  updateTopData(slice) {

    this.setState((state) => {
      let hd = {}
      let old = state.hoverData
      let changed = false

      let newData = state.newData
      let totals = {}
      for (let i = 0; i < newData.length; i = i + 1) {
        totals[newData[i].id] = newData[i].total
      }

      for (let i = 0; i < slice.points.length; i = i + 1) {
        let p = slice.points[i]
        hd[p["serieId"]] = p["data"]["y"] + " / " + totals[p["serieId"]]
        if (old[p["serieId"]] !== hd[p["serieId"]]) {
          changed = true
        }
      }
      hd["date"] = slice.points[0]["data"]["xFormatted"]
      if (old["date"] !== hd["date"]) {
        changed = true
      }
      if (Object.keys(old).length !== Object.keys(hd).length) {
        changed = true
      }

      if (changed) {
        //console.log("setting data", hd)
        return {
          hoverData: hd
        }
      }
      return {}
    })
  }

  /*
  Changes the timescale
  */
  changeTimescale() {
    this.setState((state) => {
      let dts = state.daysToShow
      if (dts === 7) {
        dts = 14;
      } else if (dts === 14) {
        dts = 30;
      } else if (dts === 30) {
        dts = 90;
      } else {
        dts = 7;
      }

      //find the totals.
      let newData = state.newData
      let totals = {}
      for (let i = 0; i < newData.length; i = i + 1) {
        totals[newData[i].id] = newData[i].total
      }

      return {
        daysToShow: dts,
        hoverData: {},
      }
    }, () => {
      this.loadData()
    })
  }

  render() {
    return (
      <div className="StatisticsGraph">
        <div className="StatisticsGraphTop">
          <DualImage image={ImageXButton} className="StatisticsGraphXButton" onClick={this.props.close} />
          {/* Date */}
          <div className="StatisticsGraphSelector">
            <div className="StatisticsGraphSelectorTitle" onClick={this.changeTimescale}>
              { this.state.daysToShow === 7 &&
                <span>
                  Last Week
                </span>
              }
              { this.state.daysToShow === 14 &&
                <span>
                  Last 14 Days
                </span>
              }
              { this.state.daysToShow === 30 &&
                <span>
                  Last Month
                </span>
              }
              { this.state.daysToShow === 90 &&
                <span>
                  Last 3 Months
                </span>
              }
            </div>
            <div className="StatisticsGraphSelectorValue" style={{paddingTop:"20px"}}>
              {this.state.hoverData.date !== undefined ? this.state.hoverData.date : "–"}
            </div>
          </div>
          {/* Views */}
          <div className="StatisticsGraphSelector">
            <div className={"StatisticsGraphSelectorButton " + (this.state.showing.includes("Views") ? "StatisticsGraphSelectorButtonSelected" : "")} onClick={this.toggleType.bind(this, "Views")}>
              <img src={Helpers.getStatImage("Views")} alt="Views" className="StatisticsGraphSelectorButtonImage1" />
              <span className="StatisticsGraphSelectorButtonText">Views</span>

              <div className="StatisticHelp">
                <img src={ImageHelpIcon} alt="Help" className="StatisticsGraphSelectorButtonImage2" />
                <div className="StatisticHelpPopup">
                  <div className="StatisticHelpPopupTitle">
                    Views
                  </div>
                  <div className="StatisticHelpPopupDescription">
                    {Helpers.getStatHelpDescription("Views")}
                  </div>
                </div>
              </div>
            </div>
            <div className="StatisticsGraphSelectorValue">
              {this.state.hoverData.Views !== undefined ? this.state.hoverData.Views : "–"}
            </div>
          </div>
          {/* Taps */}
          <div className="StatisticsGraphSelector">
            <div className={"StatisticsGraphSelectorButton StatisticsGraphSelectorButtonTaps " + (this.state.showing.includes("Taps") ? "StatisticsGraphSelectorButtonSelected" : "")} onClick={this.toggleType.bind(this, "Taps")}>
              <img src={Helpers.getStatImage("Taps")} alt="Taps" className="StatisticsGraphSelectorButtonImage1" />
              <span className="StatisticsGraphSelectorButtonText">Taps</span>

              <div className="StatisticHelp">
                <img src={ImageHelpIcon} alt="Help" className="StatisticsGraphSelectorButtonImage2" />
                <div className="StatisticHelpPopup">
                  <div className="StatisticHelpPopupTitle">
                    Taps
                  </div>
                  <div className="StatisticHelpPopupDescription">
                    {Helpers.getStatHelpDescription("Taps")}
                  </div>
                </div>
              </div>
            </div>
            <div className="StatisticsGraphSelectorValue">
              {this.state.hoverData.Taps !== undefined ? this.state.hoverData.Taps : "–"}
            </div>
          </div>
          {/* Favorites */}
          <div className="StatisticsGraphSelector">
            <div className={"StatisticsGraphSelectorButton StatisticsGraphSelectorButtonFavorites " + (this.state.showing.includes("Favorites") ? "StatisticsGraphSelectorButtonSelected" : "")} onClick={this.toggleType.bind(this, "Favorites")}>
              <img src={Helpers.getStatImage("Favorites")} alt="Favorites" className="StatisticsGraphSelectorButtonImage1" />
              <span className="StatisticsGraphSelectorButtonText">Favorites</span>

              <div className="StatisticHelp">
                <img src={ImageHelpIcon} alt="Help" className="StatisticsGraphSelectorButtonImage2" />
                <div className="StatisticHelpPopup">
                  <div className="StatisticHelpPopupTitle">
                    Favorites
                  </div>
                  <div className="StatisticHelpPopupDescription">
                    {Helpers.getStatHelpDescription("Favorites")}
                  </div>
                </div>
              </div>
            </div>
            <div className="StatisticsGraphSelectorValue">
              {this.state.hoverData.Favorites !== undefined ? this.state.hoverData.Favorites : "–"}
            </div>
          </div>
          {/* Intended Uses */}
          <div className="StatisticsGraphSelector">
            <div className={"StatisticsGraphSelectorButton StatisticsGraphSelectorButtonIntended " + (this.state.showing.includes("Intended") ? "StatisticsGraphSelectorButtonSelected" : "")} onClick={this.toggleType.bind(this, "Intended")}>
              <img src={Helpers.getStatImage("Intended")} alt="Intended" className="StatisticsGraphSelectorButtonImage1" />
              <span className="StatisticsGraphSelectorButtonText">Intended</span>

              <div className="StatisticHelp">
                <img src={ImageHelpIcon} alt="Help" className="StatisticsGraphSelectorButtonImage2" />
                <div className="StatisticHelpPopup">
                  <div className="StatisticHelpPopupTitle">
                    Intended
                  </div>
                  <div className="StatisticHelpPopupDescription">
                    {Helpers.getStatHelpDescription("Intended")}
                  </div>
                </div>
              </div>
            </div>
            <div className="StatisticsGraphSelectorValue">
              {this.state.hoverData.Intended !== undefined ? this.state.hoverData.Intended : "–"}
            </div>
          </div>
          {/* Uses */}
          <div className="StatisticsGraphSelector">
            <div className={"StatisticsGraphSelectorButton StatisticsGraphSelectorButtonUses " + (this.state.showing.includes("Uses") ? "StatisticsGraphSelectorButtonSelected" : "")} onClick={this.toggleType.bind(this, "Uses")}>
              <img src={Helpers.getStatImage("Uses")} alt="Uses" className="StatisticsGraphSelectorButtonImage1" />
              <span className="StatisticsGraphSelectorButtonText">Uses</span>

              <div className="StatisticHelp">
                <img src={ImageHelpIcon} alt="Help" className="StatisticsGraphSelectorButtonImage2" />
                <div className="StatisticHelpPopup">
                  <div className="StatisticHelpPopupTitle">
                    Uses
                  </div>
                  <div className="StatisticHelpPopupDescription">
                    {Helpers.getStatHelpDescription("Uses")}
                  </div>
                </div>
              </div>
            </div>
            <div className="StatisticsGraphSelectorValue">
              {this.state.hoverData.Uses !== undefined ? this.state.hoverData.Uses : "–"}
            </div>
          </div>
        </div>
        <div className="StatisticsGraphGraph">
          <ResponsiveLine
            data={this.state.newData}
            margin={{ top: 50, right: 50, bottom: 100, left: 50 }}
            xScale={{ type: 'time', format: '%Y-%m-%d', precision: 'millisecond' }}
            xFormat="time:%Y-%m-%d"
            //xScale={{ type: 'point' }}
            yScale={{ type: 'linear', stacked: false, min: 'auto', max: 'auto' }}
            curve="monotoneX"
            axisTop={null}
            axisRight={null}
            axisBottom={{
              orient: 'bottom',
              format: '%b %d',
              tickValues: 'every day',
              tickSize: 10,
              tickPadding: 10,
              tickRotation: -90,
              legend: '',
              legendOffset: 0,
              legendPosition: 'middle'
            }}
            /*axisBottom={{
                orient: 'bottom',
                tickSize: 5,
                tickPadding: 5,
                tickRotation: -90,
                legend: '',
                legendOffset: 36,
                legendPosition: 'middle'
            }}*/
            axisLeft={{
                orient: 'left',
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: '',
                legendOffset: -40,
                legendPosition: 'middle',
                format: value =>
                  Helpers.formatNumberOnlyInts(value)
            }}
            enableGridX={false}
            enableGridY={false}
            //colors="#393c51"
            lineWidth={4}
            pointSize={6}
            pointColor="#393c51"
            pointLabel="y"
            pointLabelYOffset={-12}
            enableArea={true}
            areaBlendMode="darken"
            areaOpacity={0.05}
            enableSlices="x"
            legends={[]}
            keys={['Views', 'Taps', 'Favorites', 'Intended', 'Uses']}
            colors={(data) => {
              return data.color
            }}
            theme={{
              axis: {
                ticks: {
                  text: {
                    fontSize: 14,
                    fontFamily: 'inherit',
                    fill: "#B3B1B5"
                  }
                },
              },
              crosshair: {
                line: {
                  strokeWidth: 1,
                  stroke: '#393c51',
                  strokeOpacity: 1,
                  strokeDasharray: 0,
                },
              },
            }}
            sliceTooltip={({ slice }) => {
              this.updateTopData(slice)
              return (
                <span></span>
                /*<div
                  style={{
                    background: 'white',
                    padding: '9px 12px',
                    border: '1px solid #bbcc00',
                  }}
                >
                  <div>x: {slice.id}</div>
                  {slice.points.map(point => (
                    <div
                      key={point.id}
                      style={{
                        color: point.serieColor,
                        padding: '3px 0',
                      }}
                    >
                      <strong>{point.serieId}</strong> [{point.data.yFormatted}]
                    </div>
                  ))}
                </div>*/
              );
            }}
          />
        </div>
      </div>
    )
  }
}

export class ShopDiv extends React.Component {

  render() {
    return (
      <div className={"ShopDiv "
          + ((this.props.userInfo.id === this.props.portalUserID && this.props.userInfo.accountType === "Admin") ? "ShopDivMine " : "")
          + (this.props.portalUserID === null ? "ShopDivNull " : "")
          + (Helpers.dateInPast(this.props.deactivationDate) ? "ShopDivDeactivated " : "")
        }
        onClick={this.props.onClick}>
        <img className="ShopLogo" alt={this.props.shopName} src={this.props.shopLogoURL} />
        <div className="ShopDivContainer">
          <div className="ShopName">
            { this.props.shopName.length >= 38 &&
              this.props.shopName
            }
            { this.props.shopName.length < 38 &&
              <Textfit mode="single" max={18} min={12}>{this.props.shopName}</Textfit>
            }
          </div>
          <div className="ShopDescription">
            {this.props.shopShortDescription}
          </div>
          <div className="ShopAddress">
            {this.props.shopAddress}
          </div>
          { this.props.shopRegionID === null &&
            <div className="ShopImage">
              <img src={ImageNoLocation} alt="No Location" />
            </div>
          }
        </div>
      </div>
    )
  }
}

export class AccountDiv extends React.Component {

  render() {
    return (
      <div className={"AccountDiv "
          + ((this.props.accessAccountID === this.props.supportAccountID && this.props.accessAccountType === "Admin") ? "AccountDivMine " : "")
          + ((this.props.accountType === "Associate") ? "AccountDivAssociate " : "")
          + (Helpers.dateInPast(this.props.deactivationDate) ? "AccountDivDeactivated " : "")
        }
        onClick={this.props.onClick}
        >
        <div className="AccountDivName">
          { this.props.accountType === "Associate" &&
            <img src={ImageAssociateDark} alt="Associate" style={{marginRight:"5px"}} />
          }
          {this.props.name}
        </div>
        <div className="AccountDivEmail">
          {this.props.email}
        </div>
        <div className="AccountDivButton">
          { this.props.accountType === "Owner" && this.props.stripeSetup === "1" &&
            <img className="AccountDivButtonLeftImage" src={ImageCreditCardCheckmark} alt="Credit Card Active" style={{top:"14px"}} />
          }
          { this.props.accountType === "Associate" && this.props.payPalSetup === "1" &&
            <img className="AccountDivButtonLeftImage" src={ImagePayPalLogoSmall} alt="PayPal Active" />
          }
          { this.props.accountType === "Associate" && this.props.payoutType === "monthly" &&
            <img className="AccountDivButtonRightImage" src={ImageCalendarMonthly} alt="Monthly Payments" />
          }
          { this.props.accountType === "Associate" && this.props.payoutType === "once" &&
            <img className="AccountDivButtonRightImage" src={ImageCalendarOnce} alt="One Time Payments" />
          }
          <MaterialButton type="TextPurpleShadow" onClick={(e) => {
            e.stopPropagation()
            this.props.takeoverAccount(this.props.id)
          }}>Access Account</MaterialButton>
        </div>
      </div>
    )
  }
}

export class AdminDiv extends React.Component {

  render() {
    return (
      <div className="AdminDiv" onClick={this.props.onClick}>
        <div className="AdminDivImage">
          <img src={this.props.image} alt={this.props.title} />
        </div>
        <div className="AdminDivContainer">
          <div className="AdminDivTitle" style={{color:this.props.color}}>
            {this.props.title}
          </div>
          <div className="AdminDivDescription">
            {this.props.description}
          </div>
        </div>
      </div>
    )
  }
}

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
  <GoogleMap defaultZoom={14} defaultCenter={{ lat: props.latitude, lng: props.longitude }} >
    <Marker position={{ lat: props.latitude, lng: props.longitude }} />
  </GoogleMap>
))

export class GoogleMapView extends React.Component {
  render() {
    return (
      <MyMapComponent
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB_jaMqPjs-uX_1oTXU8yj_mzC6d8XEQ5A&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: "176px", borderRadius: "24px", overflow: "hidden" }} />}
        containerElement={<div style={{ height: "176px", borderRadius: "24px", overflow: "hidden" }} />}
        mapElement={<div style={{ height: "176px", borderRadius: "24px", overflow: "hidden" }} />}
        latitude={parseFloat(this.props.latitude)}
        longitude={parseFloat(this.props.longitude)}
      />
    )
  }
}

const MyMapComponentRegions = withScriptjs(withGoogleMap((props) =>
  <GoogleMap defaultZoom={props.zoom ? props.zoom : 8} defaultCenter={{ lat: props.latitude, lng: props.longitude }}
    onClick={props.onClick.bind(false)}
    ref={props.setRef}
    >
    {props.children}
  </GoogleMap>
))

export class GoogleMapViewRegions extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      changeLocation: false
    }

    this.references = {}
    this.mapReference = React.createRef()
  }

  componentDidUpdate(oldProps) {
    if ((oldProps.latitude !== this.props.latitude || oldProps.longitude !== this.props.longitude) && this.mapReference.current) {
      //we need to update the center of the map to this new location
      this.mapReference.current.panTo({lat: parseFloat(this.props.latitude), lng: parseFloat(this.props.longitude)})
    }
  }

  getCenter() {
    if (this.mapReference.current) {
      return this.mapReference.current.getCenter()
    }
    return false
  }

  render() {
    return (
      <MyMapComponentRegions
        setRef={this.mapReference}
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB_jaMqPjs-uX_1oTXU8yj_mzC6d8XEQ5A&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: "100%", borderRadius: "24px", overflow: "hidden" }} />}
        containerElement={<div style={{ height: "100%", borderRadius: "24px", overflow: "hidden" }} />}
        mapElement={<div style={{ height: "100%", borderRadius: "24px", overflow: "hidden" }} />}
        latitude={parseFloat(this.props.latitude)}
        longitude={parseFloat(this.props.longitude)}
        changeLocation={this.state.changeLocation}
        zoom={this.props.zoom}
        onClick={this.props.onClick}
      >
        {/* Draw the region circles */}
        { this.props.regions.map((r, i) => (
          <Circle key={"region_" + i}
            ref={(input) => {this.references["RegionRef" + r.regionID] = input}}
            editable={r.selected && this.props.canEdit ? true : false}
            draggable={r.selected && this.props.canEdit ? true : false}
            options={{
              fillColor: r.selected ? "#8B4CFF" : (r.regionNotificationSupport === "2" ? "#393C51" : (r.regionActive === "1" ? "#3EC43F" : "#FF406C")),
              fillOpacity:0.2,
              strokeColor: r.selected ? "#8B4CFF" : (r.regionNotificationSupport === "2" ? "#393C51" : (r.regionActive === "1" ? "#3EC43F" : "#FF406C")),
              strokeOpacity:1.0,
              strokeWeight:1.0,
            }}
            onClick={() => {
              this.props.onClick(r)
            }}
            onCenterChanged={() => {
              let newCenter = this.references["RegionRef" + r.regionID].getCenter()
              let newLat = newCenter.lat()
              let newLong = newCenter.lng()
              this.props.onCenterChanged(r, newLat, newLong)
            }}
            onRadiusChanged={() => {
              let newRadius = this.references["RegionRef" + r.regionID].getRadius()
              this.props.onRadiusChanged(r, newRadius)
            }}
            center={{lat:parseFloat(r.latitude), lng: parseFloat(r.longitude)}} radius={1609.34 * parseFloat(r.regionRadius)}
            zIndex={r.selected ? 12 : 4}
            />
        ))}
        {/* Draw the region center points */}
        { this.props.regions.map((r, i) => (
          <Circle key={"region2_" + i}
            editable={false}
            draggable={false}
            options={{
              fillColor: "#393C51",
              fillOpacity:0.2,
              strokeColor: "#393C51",
              strokeOpacity:1.0,
              strokeWeight:2.0,
            }}
            center={{lat:parseFloat(r.latitude), lng: parseFloat(r.longitude)}} radius={500.0}
            zIndex={1}
            />
        ))}
        {/* Draw the points for the shops without regions */}
        { this.props.emptyShops && this.props.emptyShops.map((r, i) => (
          <Marker key={"emptyShop_" + i}
            ref={(input) => {this.references["EmptyShopRef" + r.shopID] = input}}
            position={{lat:parseFloat(r.shopLatitude), lng: parseFloat(r.shopLongitude)}}
            icon={r.selected ? ImageShopColoredPurple : (r.shopRegionID === null ? ImageShopHollow : ImageShopColored)}
            onClick={() => {
              this.props.emptyShopOnClick(r)
            }}
            zIndex={r.selected ? 10 : 9}
            />
        ))}
      </MyMapComponentRegions>
    )
  }
}

export class PromotionPreview extends React.Component {

  constructor(props) {
    super(props)

    this.callNumber = this.callNumber.bind(this)
    this.visitLink = this.visitLink.bind(this)
  }

  callNumber(number) {
    window.open('tel:' + number)
  }

  visitLink(link) {
    let win = window.open(link, '_blank');
    win.focus();
  }

  getDays() {
    let dd = ["Su", "M", "Tu", "W", "Th", "F", "Sa"]
    let results = []
    for (let i = 0; i < dd.length; i = i + 1) {
      let vv = this.props.promotion.promoValidDays.charAt(i) || "1"
      if (vv === "1") {
        results.push({
          day: dd[i],
          value: vv
        })
      }
    }
    return results
  }

  render() {

    let expDate = this.props.promotion.promoExpirationDate
    if (expDate === "3000-01-01" || expDate === "3000-01-01 00:00:00") {
      expDate = "3000-01-01"
    } else if (expDate.length > 8) {
      //parse the date into the format 03/31/95
      expDate = Helpers.formatDateShort(expDate)
    } else {
      //no need to parse the date
    }

    let shop = this.props.shop ? this.props.shop : this.props.promotion

    return (
      <div className={"PromotionPreview " + (this.props.shrink ? "PromotionPreviewShrink" : "")}>

        <div className="PromotionPreviewGray">
          <div className="PromotionPreviewWhite">
            {/* Top background image and content over the top of it */}
            <div className="PromotionPreviewBackground">
              <img src={this.props.promotion.promoImageURL ? this.props.promotion.promoImageURL : ImageBidlyPattern} className="PromotionPreviewBackgroundImage" alt="Promotion Background" />
              <div className="PromotionPreviewBackgroundImageCover" />
              <img src={ImagePromotionDownArrow} className="PromotionPreviewBackgroundDownArrow" alt="Down Arrow" />
              <img src={shop.shopLogoURL ? shop.shopLogoURL : ImageBidlyLogoWhite} className="PromotionPreviewBackgroundLogo" alt="Shop Logo" />
              <Textfit mode="single" max={30} className="PromotionPreviewBackgroundShopName" style={{height:"42px"}}>
                {shop.shopName}
              </Textfit>
              <Textfit mode="single" max={17} className="PromotionPreviewBackgroundShopShortDescription" style={{height:"24px"}}>
                {shop.shopShortDescription}
              </Textfit>
              <div className="PromotionPreviewBackgroundBar">
                <div className="PromotionPreviewBackgroundBarDot"></div>
                <div className="PromotionPreviewBackgroundBarText">Open Now</div>
                <img src={ImageMapPointIcon} className="PromotionPreviewBackgroundBarMapIcon" alt="Distance" />
                <div className="PromotionPreviewBackgroundBarText">3.1 mi</div>
                <div className="PromotionPreviewBackgroundBarGo">GO</div>
              </div>
            </div>
            {/* White bar content and buttons */}
            <div className="PromotionPreviewWhiteContent">
              <div className="PromotionPreviewWhiteContentCategory">
                <img src={Helpers.getCategoryImage(shop.shopCategory)} alt="Category" />
                <div style={{color:Helpers.getCategoryColor(shop.shopCategory)}}>
                  {shop.shopCategory}
                </div>
              </div>
              { this.props.promotion.promoTitle && this.props.promotion.promoTitle.length >= 40 &&
                <div className="PromotionPreviewWhiteContentTitle" style={{minHeight:"28px"}}>
                  <Textfit mode="multi" max={20}>
                    {this.props.promotion.promoTitle}
                  </Textfit>
                </div>
              }
              { this.props.promotion.promoTitle && this.props.promotion.promoTitle.length < 40 &&
                <div className="PromotionPreviewWhiteContentTitle">
                  <Textfit mode="single" max={20} min={14}>
                    {this.props.promotion.promoTitle}
                  </Textfit>
                </div>
              }
              { this.props.promotion.promoValidDays !== "1111111" &&
                <div className="PromotionPreviewWhiteContentValidDays">
                  { this.getDays().map((day, i) => (
                    <div className="PromotionPreviewWhiteContentValidDaysBlock">
                      {day.day}
                    </div>
                  ))}
                </div>
              }
              <div className="PromotionPreviewWhiteContentDescription">
                {this.props.promotion.promoShortDescription}
              </div>
              <div className="PromotionPreviewWhiteContentPrice">
                {"$" + Helpers.formatNumberDecimals(this.props.promotion.promoValue)}
              </div>
              <div className="PromotionPreviewWhiteContentUseDeal">
                <img src={ImageLocationWhite} alt="Use Deal" />
                <div>
                  Use Deal Now
                </div>
              </div>
              <div className="PromotionPreviewWhiteContentFavorite">
                <img src={ImageHeartRed} alt="Use Deal" />
                <div>
                  Favorite for Later
                </div>
              </div>
            </div>
          </div>
          {/* Gray bar content */}
          <div className="PromotionPreviewGrayContent">
            { expDate !== "3000-01-01" &&
              <div className="PromotionPreviewGrayContentHalf">
                <img src={ImageClockGray} alt="Clock" />
                <div className="PromotionPreviewGrayContentFourth">
                  <div className="PromotionPreviewGrayContentFourthTitle">Valid Until</div>
                  <div className="PromotionPreviewGrayContentFourthDescription">{expDate}</div>
                </div>
              </div>
            }
            <div className="PromotionPreviewGrayContentHalf">
              <img src={ImageLocationGray} alt="Location" />
              <div className="PromotionPreviewGrayContentFourth">
                <div className="PromotionPreviewGrayContentFourthTitle">Uses</div>
                <div className="PromotionPreviewGrayContentFourthDescription">{this.props.promotion.promoUseType}</div>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom details content */}
        <div className="PromotionPreviewBottomContent">
          { shop.shopAbout &&
            <div className="PromotionPreviewBottomContentAbout">
              <img src={ImageInfoBlack} alt="Info" />
              <div className="PromotionPreviewBottomContentAboutContent">
                <div className="PromotionPreviewBottomContentAboutContentTitle">
                  About this deal
                </div>
                <div className="PromotionPreviewBottomContentAboutContentValue">
                  {shop.shopAbout}
                </div>
              </div>
            </div>
          }
          <div className="PromotionPreviewBottomContentMap">
            <img src={shop.shopLogoURL} alt="Shop Logo" />
            <div className="PromotionPreviewBottomContentMapContent">
              <div className="PromotionPreviewBottomContentMapContentTitle">
                About {shop.shopName}
              </div>
            </div>
          </div>
          <div className="PromotionPreviewBottomContentMapMap">
            <GoogleMapView latitude={shop.shopLatitude} longitude={shop.shopLongitude} />
          </div>
          {/* Address */}
          <div className="PromotionPreviewBottomContentInfo">
            <img src={ImageMapPointIconDark} alt="Address"/>
            <div className="PromotionPreviewBottomContentInfoContent">
              <div className="PromotionPreviewBottomContentInfoContentTitle">
                Address
              </div>
              <div className="PromotionPreviewBottomContentInfoContentSubtitle">
                {shop.shopAddress}
              </div>
            </div>
          </div>
          {/* Hours */}
          <div className="PromotionPreviewBottomContentInfo">
            <img src={ImageClockDark} alt="Address"/>
            <div className="PromotionPreviewBottomContentInfoContent">
              <div className="PromotionPreviewBottomContentInfoContentTitle">
                Hours
              </div>
              <div className="PromotionPreviewBottomContentInfoContentSubtitle">
                {shop.shopHoursText}
              </div>
            </div>
          </div>
          {/* Phone Number */}
          { shop.shopPhoneNumber &&
            <div className="PromotionPreviewBottomContentInfo PromotionPreviewBottomContentInfoSelectable" style={{alignItems:"center"}}
              onClick={this.callNumber.bind(this, shop.shopPhoneNumber)}>
              <img src={ImagePhoneDark} alt="Phone Number"/>
              <div className="PromotionPreviewBottomContentInfoContent">
                <div className="PromotionPreviewBottomContentInfoContentValue">
                  {Helpers.parsePhoneNumber(shop.shopPhoneNumber)}
                </div>
              </div>
            </div>
          }
          {/* Website */}
          { shop.shopWebsiteURL &&
            <div className="PromotionPreviewBottomContentInfo PromotionPreviewBottomContentInfoSelectable" style={{alignItems:"center"}}
              onClick={this.visitLink.bind(this, shop.shopWebsiteURL)}>
              <img src={ImageSiteDark} alt="Website"/>
              <div className="PromotionPreviewBottomContentInfoContent">
                <div className="PromotionPreviewBottomContentInfoContentValue">
                  {shop.shopWebsiteURL}
                </div>
              </div>
            </div>
          }
          {/* Twitter */}
          { shop.shopTwitterLink &&
            <div className="PromotionPreviewBottomContentInfo PromotionPreviewBottomContentInfoSelectable" style={{alignItems:"center"}}
              onClick={this.visitLink.bind(this, shop.shopTwitterLink)}>
              <img src={ImageTwitterDark} alt="Twitter"/>
              <div className="PromotionPreviewBottomContentInfoContent">
                <div className="PromotionPreviewBottomContentInfoContentValue">
                  {shop.shopTwitterLink}
                </div>
              </div>
            </div>
          }
          {/* Facebook */}
          { shop.shopFacebookLink &&
            <div className="PromotionPreviewBottomContentInfo PromotionPreviewBottomContentInfoSelectable" style={{alignItems:"center"}}
              onClick={this.visitLink.bind(this, shop.shopFacebookLink)}>
              <img src={ImageFacebookDark} alt="Facebook"/>
              <div className="PromotionPreviewBottomContentInfoContent">
                <div className="PromotionPreviewBottomContentInfoContentValue">
                  {shop.shopFacebookLink}
                </div>
              </div>
            </div>
          }
          {/* Instagram */}
          { shop.shopInstagramLink &&
            <div className="PromotionPreviewBottomContentInfo PromotionPreviewBottomContentInfoSelectable" style={{alignItems:"center"}}
              onClick={this.visitLink.bind(this, shop.shopInstagramLink)}>
              <img src={ImageInstagramDark} alt="Instagram"/>
              <div className="PromotionPreviewBottomContentInfoContent">
                <div className="PromotionPreviewBottomContentInfoContentValue">
                  {shop.shopInstagramLink}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export class MoneyCircle extends React.Component {

  render() {
    let newInt = this.props.value === "-1" ? "0" : this.props.value
    let newValue = newInt.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    return (
      <div className={"MoneyCircle " + (newInt === "0" ? "MoneyCircleGray" : "")}>
        <Textfit mode="single" max={42}>{ "$" + newValue }</Textfit>
      </div>
    )
  }
}

export class RegionDiv extends React.Component {

  render() {
    return (
      <div className="RegionDiv">
        <div className="RegionDivTop">
          <div className="RegionDivName">
            <Textfit mode="single" max={18}>{this.props.region.regionName.length > 0 ? this.props.region.regionName : "New Region"}</Textfit>
          </div>
          <div className="RegionDivRadius">
            <Textfit mode="single" max={14}>{"( " + Helpers.formatNumberDecimals(this.props.region.regionRadius) + " mi radius )"}</Textfit>
          </div>
        </div>
        <div className="RegionDivMiddle">
          <div className="RegionDivShopCount">
            {this.props.region.shopCount + " Shops"}
          </div>
        </div>
        <div className="RegionDivBottom">
          { this.props.region.regionActive === "1" &&
            <div className="RegionDivActive">
              Active
            </div>
          }
          { this.props.region.regionActive === "0" &&
            <div className="RegionDivInactive">
              Inactive
            </div>
          }
          <div className="RegionDivCount">
            {Helpers.formatNumber(this.props.region.regionUserCount) + " / " + Helpers.formatNumber(this.props.region.regionUsersRequired) + " - " + Helpers.formatNumber(this.props.region.regionPremiumUserCount)}
          </div>
        </div>
      </div>
    )
  }
}
